import { ErrorMessage } from '@hookform/error-message';
import classNames from 'classnames';
import { Error } from 'components/InputsMex/containers/components';
import SimpleErrorMessage from 'components/InputsMex/containers/SimpleErrorMessage';
import { HideField } from 'components/InputsMex/inputs';
import { Button as BtnPrime } from 'primereact/button';
import React, { useState } from 'react';
import { Button, ButtonGroup, Modal } from 'react-bootstrap';
import { Controller, useFormContext } from 'react-hook-form';
import styled from 'styled-components';
import COLORS from 'utils/constants/COLORS';
import { regex } from 'utils/validaciones';
import { match } from 'x-match-expression';
import { SimpleCheckBoxA } from '../componentes/entradas';
import './styles.scss';

export const OpcionesContratante = ({ name = '', rules, opciones = [] }) => {
  const { control, errors, setValue } = useFormContext();
  return (
    <React.Fragment>
      <HideField name={`${name}Label`} />
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ onChange, value }) => {
          return (
            <React.Fragment>
              <ButtonGroup className="row d-flex d-wrap justify-content-center">
                {opciones?.map((opcion, index) => (
                  <Button
                    key={`opcion-${name}-${index}`}
                    className={`col-xl-3 col-md-4 col-sm-12 mx-2 text-center custom-button-group ${
                      value === opcion?.value ? 'button-active' : ''
                    }`}
                    onClick={() => {
                      onChange(opcion?.value);
                      setValue(`${name}Label`, opcion?.label);
                    }}
                  >
                    <img
                      src={opcion?.img}
                      alt={`icono-${name}-${index}`}
                      height="100em"
                      width="100px"
                    />
                    <h4 className="text-capitalize">{opcion?.label}</h4>
                  </Button>
                ))}
              </ButtonGroup>

              <div className="text-center mx-auto">
                <ErrorMessage
                  name={name}
                  errors={errors}
                  render={({ message }) => <Error width="95%">{message}</Error>}
                />
              </div>
            </React.Fragment>
          );
        }}
      />
    </React.Fragment>
  );
};

const CabeceraPlanes = ({ opcion, stripColor }) => (
  <div style={{ height: '250px' }}>
    <div
      className="w-100 font-mex text-mex text-center font-20px mt-4"
      style={{ backgroundColor: stripColor, paddingBottom: '0.5rem' }}
    >
      <h4>{opcion?.producto}</h4>
    </div>
    <h6 className="font-source-sans-regular text-mex my-3 text-center">
      Prima total anual
    </h6>
    <h5 className=" font-source-sans-regular text-center font-mex text-mex font-weight-bold text-primary h3 my-4 font-30px">
      ${opcion?.precioFormatoAnual}
    </h5>
    <h6
      className="font-source-sans-regular text-center"
      style={{ color: COLORS.cyan }}
    >
      desde ${opcion.precioFormatoMensual} pago mensual*
    </h6>
  </div>
);

export const OpcionesPlanes = ({
  name = '',
  rules,
  opciones = [],
  exclusiones = '',
}) => {
  const [showModal, setshowModal] = useState(false);

  const { control, errors } = useFormContext();
  const stripColors = ['#C0E7F7', '#F2B773', '#B598E3', '#9ADDD8'];

  const filas = Array.from({ length: opciones[0]?.coberturas.length }, (v, i) => i);

  return (
    <React.Fragment>
      <Controller
        control={control}
        name={name}
        rules={rules}
        render={({ onChange, value }) => {
          if (!value && opciones?.length > 0) {
            onChange(opciones[0]?.id);
          }

          return (
            <React.Fragment>
              <div className="d-none d-lg-block">
                <ButtonGroup>
                  <div className="container-Hogar-planes">
                    <div></div>
                    {opciones?.map((opcion, index) => (
                      <div
                        key={`op-cob-hogar${index}`}
                        className={classNames('plan-pago-container cb-opHogar', {
                          'plan-activo': value === opcion?.id,
                          'card-login-mex': value !== opcion?.id,
                        })}
                        onClick={() => onChange(opcion?.id)}
                      >
                        <CabeceraPlanes
                          opcion={opcion}
                          stripColor={stripColors[index]}
                        />
                      </div>
                    ))}

                    {filas.map((_, i) => {
                      let opcion1 = opciones[0].coberturas[i];
                      return (
                        opcion1?.visible && (
                          <React.Fragment key={`opci2123${i}`}>
                            <div className="font-source-sans-regular font-19px col text-left">
                              {opcion1?.cobertura}
                              <BtnPrime
                                type="button"
                                style={{ borderRadius: '25%' }}
                                className="p-button-text p-button-plain p-0 pl-1 font-20px"
                                tooltip={opcion1?.descripcion ?? ''}
                              >
                                <i
                                  className="pi pi-question-circle"
                                  style={{ fontSize: '1rem' }}
                                />
                              </BtnPrime>
                            </div>
                            {opciones.map((opcion, j) => (
                              <div
                                key={`opci2${j}`}
                                className={`d-flex justify-content-center px-3 ${
                                  value === opcion?.id
                                    ? 'plan-activo card-border-lateral-activo '
                                    : 'card-border-lateral'
                                }`}
                                style={{
                                  borderTop: '0px !important',
                                  borderBottom: '0px !important',
                                }}
                                onClick={() => onChange(opcion?.id)}
                              >
                                <div className="font-source-sans-regular font-19px text-lg-center text-left">{`${opcion?.coberturas[i]?.precio}`}</div>
                              </div>
                            ))}
                          </React.Fragment>
                        )
                      );
                    })}
                    <div></div>
                    {opciones?.map((opcion, index) => (
                      <div
                        key={`opcines11${index}`}
                        className={`pt-3 ${
                          value === opcion?.id
                            ? 'plan-activo card-border-lateral-activo '
                            : 'card-border-lateral'
                        }`}
                      >
                        <Button
                          variant={
                            value === opcion?.id ? 'primary' : 'outline-primary'
                          }
                          className="mx-auto text-center w-100"
                          style={{ whiteSpace: 'break-spaces' }}
                          onClick={() => onChange(opcion?.id)}
                        >
                          <span className="text-wrap">ELIJO ESTE PLAN</span>
                        </Button>
                      </div>
                    ))}
                  </div>
                </ButtonGroup>
              </div>
              <div className="d-lg-none">
                <ButtonGroup className="row d-flex justify-content-center">
                  {opciones?.map((opcion, index) => {
                    const stripColor = stripColors[index];
                    return (
                      <div
                        className="col-md-6 col-lg-2  col-12"
                        key={`opcion-${name}-${index}`}
                        onClick={() => onChange(opcion?.id)}
                      >
                        <div
                          className={classNames('plan-pago-container', {
                            'plan-activo': value === opcion?.id,
                            'card-login-mex': value !== opcion?.id,
                          })}
                        >
                          <CabeceraPlanes opcion={opcion} stripColor={stripColor} />
                          <div className="plan-pago-coberturas">
                            {opcion?.coberturas?.map(
                              (cobertura, j) =>
                                cobertura?.visible && (
                                  <div
                                    className="mb-2 font-source-sans-regular font-19px"
                                    key={cobertura?.cobertura}
                                  >
                                    <CoberturaXL
                                      length={cobertura?.cobertura?.length}
                                    >
                                      <div className="row d-flex justify-content-center mx-3">
                                        <div className="col text-left">
                                          {cobertura?.cobertura}
                                          <BtnPrime
                                            type="button"
                                            style={{ borderRadius: '25%' }}
                                            className="p-button-text p-button-plain p-0 pl-1 font-20px"
                                            tooltip={cobertura?.descripcion ?? ''}
                                          >
                                            <i
                                              className="pi pi-question-circle"
                                              style={{ fontSize: '1rem' }}
                                            />
                                          </BtnPrime>
                                        </div>
                                        <div className="col text-left align-self-center">
                                          <p className="font-source-sans-regular">
                                            {`${cobertura?.precio}`}
                                          </p>
                                        </div>
                                      </div>
                                    </CoberturaXL>
                                  </div>
                                ),
                            )}
                          </div>
                        </div>
                        <div className="d-flex justify-content-center w-100 my-3">
                          <Button
                            variant={
                              value === opcion?.id ? 'primary' : 'outline-primary'
                            }
                            className="mx-auto text-center w-100"
                            style={{ whiteSpace: 'break-spaces' }}
                            onClick={() => onChange(opcion?.id)}
                          >
                            <span className="text-wrap">ELIJO ESTE PLAN</span>
                          </Button>
                        </div>
                      </div>
                    );
                  })}
                </ButtonGroup>
              </div>

              <div className="text-center mx-auto">
                <ErrorMessage
                  name={name}
                  errors={errors}
                  render={({ message }) => <Error width="95%">{message}</Error>}
                />
              </div>
            </React.Fragment>
          );
        }}
      />

      <div className="terminos-hogar mt-2 ">
        <div>
          <SimpleCheckBoxA
            name="terminos"
            label={
              <div
                htmlFor=""
                className="ml-1 btn text-primary"
                style={{ whiteSpace: 'normal', textAlign: 'start' }}
                onClick={() => setshowModal(true)}
              >
                <strong>
                  Por favor verifique si su vivienda es Asegurable, da click aquí
                </strong>
              </div>
            }
            rules={{ required: regex.requiredMessage }}
            defaultValue={false}
            id="terminos"
            type="normal"
            onClick={() => setshowModal(true)}
          />
          <SimpleErrorMessage name="terminos" />
        </div>
      </div>
      <Modal
        show={showModal}
        onHide={() => setshowModal(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        contentClassName={'modal-content-hogar'}
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>
          <div dangerouslySetInnerHTML={{ __html: exclusiones }}></div>
        </Modal.Body>
        <Modal.Footer>
          <button className="btn btn-primary" onClick={() => setshowModal(false)}>
            Cerrar
          </button>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
};



const CoberturaXL = styled.div`
  font-size: 1rem;
  color: #151515;
  @media (min-width: 1290px) {
    height: ${(props) =>
      match(props.length)
        .case((n) => n >= 0 && n <= 30, '20px')
        .case((n) => n >= 31 && n <= 50, '30px')
        .case((n) => n >= 51 && n <= 80, '50px')
        .case((n) => n >= 81 && n <= 85, '60px')
        .case((n) => n >= 91 && n <= 120, '100px')
        .default('100px')};
  }
  align-items: center;

  & .info {
    font-weight: bold;
  }
`;
